import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchLinks, fetchProfile } from "@/lib/api";
import { ProfileHeader } from "@/components/ProfileHeader";
import { LinkButton } from "@/components/LinkButton";
import { stagger } from "@/lib/motion";

const Skeleton = () => (
  <div className="fold mx-auto flex max-w-[480px] flex-col items-center px-4 safe-top" data-testid="links-loading">
    <div className="h-[102px] w-[102px] rounded-full bg-[#EEE] animate-pulse" />
    <div className="mt-4 h-6 w-40 rounded-md bg-[#EEE] animate-pulse" />
    <div className="mt-2 h-4 w-56 rounded-md bg-[#EEE] animate-pulse" />
    <div className="mt-6 w-full space-y-3">
      {[0, 1, 2].map((i) => <div key={i} className="h-[54px] w-full rounded-[14px] bg-[#EEE] animate-pulse" />)}
    </div>
  </div>
);

export default function LinksPage() {
  const [profile, setProfile] = useState(null);
  const [links, setLinks] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    Promise.all([fetchProfile(), fetchLinks()])
      .then(([p, l]) => { setProfile(p); setLinks(l); })
      .catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div className="fold flex items-center justify-center px-6 text-center text-sm text-[#666]" data-testid="links-error">
        Não foi possível carregar os links. Tente novamente em instantes.
      </div>
    );
  }
  if (!profile) return <Skeleton />;

  const accentStyle = { "--accent": profile.accent, "--accent-hover": profile.accent + "E6" };

  return (
    <main style={accentStyle} className="mx-auto w-full max-w-[480px] px-4 sm:px-6" data-testid="links-page">
      <motion.section
        variants={stagger}
        initial="hidden"
        animate="show"
        className="flex flex-col safe-top pb-8"
        data-testid="first-fold"
      >
        <ProfileHeader profile={profile} />

        <div className="mt-6 flex flex-col gap-3" data-testid="primary-links">
          {links.map((link) => <LinkButton key={link.id} link={link} />)}
        </div>
      </motion.section>

      <footer className="pb-8 safe-bottom flex flex-col items-center gap-1.5 text-center text-xs text-[#999]" data-testid="footer">
        <span data-testid="footer-handle">{profile.handle}</span>
        <a
          href="https://www.altagency.com.br"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-agency-link"
          className="text-[#999] hover:text-[#666] transition-colors"
        >
          Site feito por <span className="font-semibold">Alta Agency</span>
        </a>
      </footer>
    </main>
  );
}
